import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import LandingFooter from "../components/LandingFooter";
import LandingHeader from "../components/LandingHeader";
import { HashLink as Link } from "react-router-hash-link";

function AboutPage() {
  return (
    <div className="flex-col h-screen bg-gray-50">
      {/* body*/}
      <div className="flex  items-center w-full h-[85%]   ">
        <div>
          <h3 className="text-3xl font-bold pb-6 text-palette_color1 antialiased  text-center font-robo2  ">
            OUR MISSION
          </h3>

          <h5 className="  font-robo  text-justify antialiased text-md mx-[17%] ">
            We are a team of developers who are passionate about building a
            better way to share code. Whenever and whenever you need to share
            code, we are here to help. We are here to help you share code with
            the world. We aim to make sharing code a breeze. Cut down on the
            time you spend on sending code snippets and setting up proper
            envoirnment to run them on your machine. No need for that anymore.
            Run it as soon as you receive it. Simply <b>share it run it</b>.
          </h5>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
